import { FunctionComponent, useCallback, useContext, useEffect, useMemo, useState } from "react";
import Modal from "../shared/Modal";
import LabeledInput from "../shared/LabeledInput";
import TextInput from "../shared/TextInput";
import { PodcastIcon, WarningIcon } from "../shared/Icon";
import "./PartyForm.css";
import Button from "../shared/Button";
import { PartyContext } from "../../utils/party/party";

interface IProps {
	open: boolean;
	onClose: () => void;
}

const PartyForm: FunctionComponent<IProps> = (props) => {
	const { open, onClose } = props;

	const [room, setRoom] = useState<string>("");
	const [pass, setPass] = useState<string>("");
	const [joining, setJoining] = useState(false);

	const { party, joinParty } = useContext(PartyContext);

	useEffect(() => {
		if (party.isInParty) { 
			setJoining(false);
			onClose();
		}
	}, [onClose, party.isInParty]);

	useEffect(() => {
		if (party.error) {
			setJoining(false);
		}
	}, [party.error]);

	const submit = useCallback(async () => {
		if (!room) { return; }
		setJoining(true);
		await joinParty(room, pass);
	}, [joinParty, pass, room]);

	const joinButton = useMemo(() => {
		if (!joining) {
			return <Button onClick={submit} disabled={!room} color="Blue" level="Primary" size="Medium" title="Join watch party" leftIcon={<PodcastIcon />} minWidth={97}>Join</Button>;
		}
		return <Button onClick={() => {}} color="Blue" level="Primary" size="Medium" title="Joining party" inProgress minWidth={97}></Button>;
	}, [joining, room, submit]);

	return <Modal
		content={<div className="partyFormContent">
			{party.error ?
				<span className="partyError"><WarningIcon /> {party.error}</span>
				: null}
			<span>Watch anime with friends by joining a party. Anyone can pause, play, or skip through the episode.</span>
			<LabeledInput label="Room name">
				<TextInput type="text" autocomplete="party-room" name="Room name" value={room} setValue={setRoom} focus={open} onEnter={submit} />
			</LabeledInput>
			<LabeledInput label="Password (Optional)">
				<TextInput type="text" value={pass} setValue={setPass} onEnter={submit} />
			</LabeledInput>
		</div>}
		footer={<div>{joinButton}</div>}
		open={open}
		onClose={onClose}
		title="Party Mode">
	</Modal>
}

export default PartyForm;